import { z } from "zod";
import { inputValuesSchema } from "./common.js";
import { actionIdSchema, messageIdSchema, runIdSchema } from "./ids.js";
import { RUN_MODES } from "./webhook.js";

/**
 * - awaiting_approval: the inputs are final and a member must approve
 * - queued: on the run queue
 * - succeeded, rejected, failed: finished
 * - held: stopped before it did anything (a cap, a missing writer result)
 * - superseded: a member picked a different action while this one waited
 */
export const RUN_STATES = ["awaiting_approval", "queued", "succeeded", "rejected", "failed", "held", "superseded"] as const;
export type RunState = (typeof RUN_STATES)[number];

export const runSchema = z.strictObject({
  id: runIdSchema,
  messageId: messageIdSchema,
  actionId: actionIdSchema,
  actionName: z.string(),
  mode: z.enum(RUN_MODES),
  state: z.enum(RUN_STATES),
  /** Filled for every source once the run leaves `queued` or reaches `awaiting_approval`. */
  inputsFinal: inputValuesSchema.optional(),
  /** Plain-language reason for rejected, failed, and held. */
  stateReason: z.string().optional(),
  createdAt: z.iso.datetime(),
  finishedAt: z.iso.datetime().optional(),
});
export type Run = z.infer<typeof runSchema>;
